import * as React from "react";

function SvgLeft(props) {
  return <svg data-name="Calque 1" viewBox="0 0 27.77 12.12" width="1em" height="1em" {...props}><path d="M27 .44a1.31 1.31 0 01.76 1v9.22c0 1-1.7 1.71-3.35 1.38L1.74 7.43a3.22 3.22 0 01-1-.35C-.5 6.36-.18 5 1.74 4.65L24.4.09a3.88 3.88 0 012.6.35z" fill="#153042" /></svg>;
}

export default SvgLeft;